export default __webpack_public_path__ + "static/media/gallery_00.f92a2bc6.jpg";